export default __webpack_public_path__ + "static/media/OsmartNavLogo.d5c969bf.png";